import { Component, OnInit, AfterViewInit, OnDestroy, ViewChildren, ElementRef, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, FormControl, FormArray, Validators, FormControlName, ValidationErrors } from '@angular/forms';
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { UserService } from "./user.service";
import { IUserListModel, IUser, IGrant, IUserDrawingPoint, UserDrawingPointModel } from "./user";
import { DataTable } from "primeng/primeng";
import { GenericValidator } from "../shared/generic-validator";

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";
import { DataTableDirective } from "angular-datatables";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { LoaderService } from "../LoaderService";
declare var $: any;

@Component({
    templateUrl: "./users.component.html"
})
export class UsersComponent implements OnInit, AfterViewInit {
    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
    public pageTitle: string = 'Users';
    public userPopUpTitle: string = '';
    public userPopUpSubtitleShow: boolean = false;
    public userPopUpBtnText: string = '';
    usersList: IUserListModel[];
    grantsList: IGrant[];
    userDrawingPointList: IUserDrawingPoint[];
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;
    dtOptions: DataTables.Settings = {};
    dtTrigger: Subject<any> = new Subject();

    userForm: FormGroup;
    userDrawingForm: FormGroup;
    user: IUser;
    userDrawingPointModel: UserDrawingPointModel;
    public showLoginInfo: boolean = true;
    uservalidationmsgs = [];

    // Use with the generic validation message class
    displayMessage: { [key: string]: string } = {};
    private validationMessages: { [key: string]: { [key: string]: string } };
    private genericValidator: GenericValidator;

    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private appCommonService: AppCommonService,
        public userService: UserService,
        public headerAndNavigationService: HeaderAndNavigationService,
        public loaderService: LoaderService
    ) {
        this.appCommonService.pageContentAdditionalClass = "";
        this.appCommonService.pageName = this.pageTitle;

        // Defines all of the validation messages for the form.
        // These could instead be retrieved from a file or database.
        this.validationMessages = {
            firstName: {
                required: 'First name is required.'
            },
            lastName: {
                required: 'Last name is required.'
            },
            email: {
                required: 'Email is required.',
                pattern: 'Invalid email address.'
            },
            username: {
                required: 'User name is required.'
            },
            password: {
                required: 'Password is required.',
                minlength: 'Password must be at least 8 characters ',
                pattern: "Password must have at least one non letter or digit character. Password must have at least one digit ('0'-'9'). Password must have at least one uppercase ('A'-'Z')"
            }
        };

        // Define an instance of the validator for use with this form, 
        // passing in this form's set of validation messages.
        this.genericValidator = new GenericValidator(this.validationMessages);
    }

    get grants(): FormArray {
        return <FormArray>this.userForm.get('grants');
    }

    get accesspoints(): FormArray {
        return <FormArray>this.userDrawingForm.get('accesspoints');
    }

    ngOnInit(): void {
        this.headerAndNavigationService.showhideNav(false, true);
        this.userForm = this.fb.group({
            title: '',
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            jobTitle: '',
            email: ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+')]],
            username: '',
            password: '',
            grants: this.fb.array([])
        });

        this.userDrawingForm = this.fb.group({
            id: '',
            accesspoints: this.fb.array([])
        });

        this.dtOptions = {
            dom: 'tp',
            pageLength: 10,
            paging: true,
            columns: [{ orderable: true }, { orderable: true }, { orderable: true }, { orderable: false }]
        }
        this.loadUsersListInit();
    }

    ngAfterViewInit(): void {
        // Watch for the blur event from any input element on the form.
        let controlBlurs: Observable<any>[] = this.formInputElements
            .map((formControl: ElementRef) => Observable.fromEvent(formControl.nativeElement, 'blur'));

        // Merge the blur event observable with the valueChanges observable
        Observable.merge(this.userForm.valueChanges, ...controlBlurs).debounceTime(500).subscribe(value => {
            this.displayMessage = this.genericValidator.processMessages(this.userForm);
        });
    }

    loadUsersListInit() {
        this.authService.showLoader = true;
        this.loadUsersList();
    }

    loadUsersList() {
        this.userService.getUsersList()
            .subscribe(
                (users: IUserListModel[]) => {

                    this.usersList = users;
                    this.dtTrigger.next();
                    this.loaderService.display(false);
                    this.authService.showLoader = false;
                },
                (error: any) => {
                    this.userService.showError("Users retrieval problem", <any>error);
                    this.loaderService.display(false);
                    this.authService.showLoader = false;
                }
            );
    }

    addUser() {
        this.getUser("0");
    }

    editUser(user: IUserListModel) {
        this.getUser(user.id);
    }

    closeWindow() {
        $('#usersModal').modal('hide');
    }

    getUser(id: string): void {
        //debugger;
        this.userService.msgs = [];
        this.loaderService.display(true);
        this.userService.getUser(id)
            .subscribe(
                (user: IUser) => {
                    this.loaderService.display(false);
                    this.onUserRetrieved(user);
                },
                (error: any) => {
                    this.loaderService.display(false);
                    this.userService.showError("User retrieval problem", <any>error);
                    this.headerAndNavigationService.RedirectToLogin();
                }
            );
    }

    onUserRetrieved(user: IUser): void {
        if (this.userForm) {
            this.reSetForm();
        }
        this.user = user;

        if (this.user.id === "0") {
            this.userPopUpTitle = 'Create New user';
            this.userPopUpSubtitleShow = true;
            this.userPopUpBtnText = 'Create';
            this.setAdditionalValidation();
        } else {
            this.userPopUpTitle = `Edit user - ${this.user.firstName + ' ' + this.user.lastName}`;
            this.userPopUpSubtitleShow = false;
            this.userPopUpBtnText = 'Save';
            this.clearAdditionalValidation();
        }

        // Update the data on the form
        this.userForm.patchValue({
            title: this.user.title,
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            jobTitle: this.user.jobTitle,
            email: (this.user.email !== null ? this.user.email.replace(" (duplicate email)", "") : "")
        });
        this.grantsList = this.userService.getUserGrants();
        this.userForm.setControl('grants', this.fb.array(this.user.grants || []));
        for (let grant of this.user.grants) {
            let index = this.grantsList.findIndex(x => x.value == grant);
            this.grantsList[index].avail = true;
        }
        $('#usersModal').modal('show');
    }

    deleteUser(user: IUserListModel): void {
        if (confirm(`Do you definitely want to delete the user ${user.name}?`)) {
            this.loaderService.display(true);
            this.userService.deleteUser(user.id)
                .subscribe(
                    () => {
                        //this.loaderService.display(false);
                        this.loadUsersList();
                        this.onSaveComplete();
                    },
                    (error: any) => {
                        this.loaderService.display(false);
                        this.userService.showError("User delete problem", <any>error);
                    }
                );
        }
    }

    onPermissionChange(email: string, isChecked: boolean) {
        const emailFormArray = this.grants;
        if (isChecked) {
            emailFormArray.push(new FormControl(email));
        } else {
            let index = emailFormArray.controls.findIndex(x => x.value == email)
            emailFormArray.removeAt(index);
        }
    }

    saveUser(): void {
        if (this.userForm.valid) {
            // Copy the form values over the product object values
            let p = Object.assign({}, this.user, this.userForm.value);
            this.loaderService.display(true);
            this.userService.saveUser(p)
                .subscribe(
                    () => {
                        $('#usersModal').modal('hide');
                        this.userService.showSuccess("Success", "Your updates to the user information has been received and will be updated within 15 mins.")

                        //this.loaderService.display(false);
                        this.loadUsersList();
                        this.onSaveComplete();
                    },
                    (error: any) => {
                        //$('#usersModal').modal('hide');
                        this.loaderService.display(false);
                        this.userService.showError("User create / edit problem", <any>error, true);
                    }
                );
        } else if (!this.userForm.dirty) {
            this.onSaveComplete();
            $('#usersModal').modal('hide');
        }
    }

    reSetForm() {
        this.userForm.reset();
    }

    onSaveComplete(): void {
        this.reSetForm();
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
        });
    }

    setAdditionalValidation(): void {
        const usernameControl = this.userForm.get('username');
        const passwordControl = this.userForm.get('password');
        usernameControl.setValidators(Validators.required);
        //passwordControl.setValidators([Validators.required, Validators.minLength(8), Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')]);
        passwordControl.setValidators([Validators.required]);
        usernameControl.updateValueAndValidity();
        passwordControl.updateValueAndValidity();
        this.showLoginInfo = true;
    }

    clearAdditionalValidation(): void {
        const usernameControl = this.userForm.get('username');
        const passwordControl = this.userForm.get('password');
        usernameControl.clearValidators();
        passwordControl.clearValidators();
        usernameControl.updateValueAndValidity();
        passwordControl.updateValueAndValidity();
        this.showLoginInfo = false;
    }

    editUserDrawingPointAccess(user: IUserListModel) {
        this.getUserDrawingPointAccess(user.id);
    }

    getUserDrawingPointAccess(id: string): void {
        this.loaderService.display(true);
        this.userService.getUserDrawingPointAccess(id)
            .subscribe(
                (userDrawingPoints: IUserDrawingPoint[]) => {
                    this.loaderService.display(false);
                    //debugger;
                    this.onUserDrawingPointAccessRetrieved(id, userDrawingPoints);
                },
                (error: any) => {
                    this.loaderService.display(false);
                    this.userService.showError("User drawing point access retrieval problem", <any>error);
                }
            );
    }

    onUserDrawingPointAccessRetrieved(id: string, userDrawingPoints: IUserDrawingPoint[]): void {
        if (this.userDrawingForm) {
            this.reSetUserDrawingPointAccessForm();
        }
        this.userDrawingPointList = userDrawingPoints;
        // Update the data on the form
        this.userDrawingForm.patchValue({
            id: id
        });
        this.userDrawingForm.setControl('accesspoints', this.fb.array(userDrawingPoints || []));
        $('#usersDrawingModal').modal('show');
    }

    reSetUserDrawingPointAccessForm() {
        this.userDrawingForm.reset();
    }

    closeUserDrawingPointAccessWindow() {
        $('#usersDrawingModal').modal('hide');
    }

    saveUserDrawingPointAccess(): void {
        if (this.userDrawingForm.valid) {
            // Copy the form values over the product object values
            let p = Object.assign({}, this.userDrawingPointModel, this.userDrawingForm.value);
            p.accesspoints = this.userDrawingPointList;
            this.loaderService.display(true);
            this.userService.saveUserDrawingPointAccess(p)
                .subscribe(
                    () => {
                        //debugger;
                        $('#usersDrawingModal').modal('hide');
                        this.userService.showSuccess("Success", "Your updates to the user information has been received and will be updated within 15 mins.")
                        this.loaderService.display(false);
                        this.onsaveUserDrawingPointAccessComplete();
                    },
                    (error: any) => {
                        this.loaderService.display(false);
                        this.userService.showError("User drawing point access save problem", <any>error, true);
                    }
                );
        } else if (!this.userForm.dirty) {
            this.onSaveComplete();
            $('#usersDrawingModal').modal('hide');
        }
    }

    onsaveUserDrawingPointAccessComplete(): void {
        this.reSetUserDrawingPointAccessForm();
    }

    selectAllAccountChange(e) {
        if (e.target.checked) {
            this.userDrawingPointList.forEach(eachObj => {
                eachObj.accessEnabled = true;
            });
        }
        else {
            this.userDrawingPointList.forEach(eachObj => {
                eachObj.accessEnabled = false;
            });
        }
    }

    getFormValidationErrors() {
        Object.keys(this.userForm.controls).forEach(key => {

            const controlErrors: ValidationErrors = this.userForm.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/users/users.component.ts